module.exports = __webpack_public_path__ + "img/ft-big-deal.8e383860.webp";